import './forkandflavor/style';
import FormStructure from './forkandflavor/form_structure';

export default FormStructure;